// ── BOTANIX ADDONS — Shared across all booking forms ─────────────────────────
// Edit prices here to update across entire ERP

export const ADDON_LIST = [
 // Entertainment
 { id:'dj', name:'DJ', unit:'per event', category:'Entertainment', defaultPrice:15000 },
 { id:'anchor', name:'Anchor / Emcee', unit:'per event', category:'Entertainment', defaultPrice:8000 },
 { id:'photo', name:'Photography', unit:'per event', category:'Media', defaultPrice:15000 },
 { id:'video', name:'Videography', unit:'per event', category:'Media', defaultPrice:20000 },
 { id:'drone', name:'Drone Coverage', unit:'per event', category:'Media', defaultPrice:10000 },
 // AV & Tech
 { id:'projector', name:'Projector & Screen', unit:'per day', category:'AV & Tech', defaultPrice:5000 },
 { id:'led_screen', name:'LED Screen', unit:'per day', category:'AV & Tech', defaultPrice:12000 },
 { id:'pa_system', name:'PA / Sound System', unit:'per event', category:'AV & Tech', defaultPrice:8000 },
 { id:'conf_hall', name:'Conference Hall', unit:'per day', category:'Venue', defaultPrice:20000 },
 // Outdoor
 { id:'bonfire', name:'Bonfire', unit:'per event', category:'Outdoor', defaultPrice:3000 },
 { id:'gazebo', name:'Gazebo', unit:'per unit', category:'Outdoor', defaultPrice:5000 },
 { id:'tentage', name:'Tentage / Shamiana', unit:'per event', category:'Outdoor', defaultPrice:15000 },
 { id:'team_building', name:'Team Building Activity',unit:'per event', category:'Activities', defaultPrice:10000 },
 // Decor
 { id:'props', name:'Props & Styling', unit:'per event', category:'Decor', defaultPrice:8000 },
 { id:'decor', name:'Decor Package', unit:'per event', category:'Decor', defaultPrice:25000 },
 { id:'floral', name:'Floral Arrangement', unit:'per event', category:'Decor', defaultPrice:10000 },
 // F&B
 { id:'bar_counter', name:'Bar Counter', unit:'per event', category:'F&B', defaultPrice:15000 },
 { id:'mocktail', name:'Mocktail Counter', unit:'per event', category:'F&B', defaultPrice:8000 },
 { id:'chaat', name:'Chaat Counter', unit:'per event', category:'F&B', defaultPrice:6000 },
 { id:'ice_cream', name:'Ice Cream Counter', unit:'per event', category:'F&B', defaultPrice:5000 },
 { id:'welcome_drink', name:'Welcome Drink', unit:'per person', category:'F&B', defaultPrice:150 },
 // Services
 { id:'generator', name:'Generator', unit:'per day', category:'Services', defaultPrice:5000 },
 { id:'valet', name:'Valet Parking', unit:'per event', category:'Services', defaultPrice:8000 },
 { id:'security', name:'Security Personnel', unit:'per person', category:'Services', defaultPrice:1500 },
 { id:'other1', name:'Other Add-on 1', unit:'custom', category:'Other', defaultPrice:0 },
 { id:'other2', name:'Other Add-on 2', unit:'custom', category:'Other', defaultPrice:0 },
];

export const ADDON_CATEGORIES = [...new Set(ADDON_LIST.map(a=>a.category))];

// Get addon prices from localStorage (editable by admin)
export const getAddonPrices = () => {
 try {
 const saved = JSON.parse(localStorage.getItem('botanix_addon_prices')||'{}');
 return ADDON_LIST.reduce((acc,a)=>({...acc,[a.id]:saved[a.id]??a.defaultPrice}),{});
 } catch { return ADDON_LIST.reduce((acc,a)=>({...acc,[a.id]:a.defaultPrice}),{}); }
};

// Save addon prices
export const saveAddonPrices = (prices) => {
 localStorage.setItem('botanix_addon_prices', JSON.stringify(prices));
};
